<template>
   <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
      <z-page title="Laporan Semen" style="min-height:0px; height:0px;">
         <div class="table_scrol" >
            <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
              <template v-for="(tab, i) in tabs" #[`item-content.${i+1}`]>

   <!-- TAB PENGELUARAN -->
               <div v-if="tab.title === 'PEMUNGUTAN'">
                  <br>
                  <div class="w-card__content content-hardcode mb3">
                     <w-form v-model="valid_pemungutan" @validate="cari_pemungutan" ref="frm_pemungutan">

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-select class="mt4 role-selector" :items="roles" v-model="pencarian_pemungutan.role_pemungutan_id" label="Pilih Peranan" placeholder="Sila pilih peranan Anda" outlined color="primary" large dark />
                           </div>
                        </w-flex>
                        <br>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan"  v-model="pencarian_pemungutan.lkp_ternakan_pemungutan_id" @input="getJurusanCarian(pencarian_pemungutan.lkp_ternakan_pemungutan_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan"  v-model="pencarian_pemungutan.lkp_jurusan_pemungutan_id" @input="getBakaCarian(pencarian_pemungutan.lkp_jurusan_pemungutan_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " v-model="pencarian_pemungutan.lkp_baka_pemungutan_id" :items="lkp_baka" label="Baka" />
                           </div>
                        </w-flex>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_pemungutan.nama_pemungutan" label="Nama Operator" />
                           </div>
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_pemungutan.id_ternakan_pemungutan" label="ID Ternakan" />
                           </div>
                           <div class="filter-col">
                              <w-input label="Tarikh Pemungutan" type="date" v-model="pencarian_pemungutan.tarikh_pemungutan"/>
                           </div>
                        </w-flex>
                     </w-form>
                     <br>
                     <w-flex justify-end class="mt2">
                       <!--  <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                           <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
                        </w-button> -->
                           <w-button class="mr2" @click="resetPencarian('PEMUNGUTAN')" bg-color="warning">
                              <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
                           </w-button>
                           <w-button class="mr2" bg-color="primary" @click="$refs.frm_pemungutan.validate()">
                              <w-icon>fal fa-search</w-icon>&nbsp;CARI
                           </w-button>
                        </w-flex>
                     </div>
                     <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN PEMUNGUTAN'">
                        <template #title>
                           SENARAI LAPORAN PEMUNGUTAN
                        </template>
                        <w-flex justify-end class="mt2">
                           <w-button bg-color="success" v-on="on" @click="createExcelPemungutan()" class="mr2">
                              <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                           </w-button>
                        </w-flex>
                        <br>
                        <div class="w-table-wrap" style="max-height: 900px;">
                            <div class="table-profil-scrol">
                              <br><br>
                              <table class="w-table" color="light" style="border:1px">
                                 <thead>
                                    <tr class="w-table__header text-center" style="border: 1px solid #000;">
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          BIL
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          TARIKH PUNGUTAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          MASA PUNGUTAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          JENIS TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          JURUSAN TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          BAKA
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          ID TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NAMA TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NO. BATCH
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NO. EJAKULASI (1-3)
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          JUMLAH PANJATAN PALSU
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          TUJAHAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          WARNA BENIH
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          SKOR LIBIDO
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          ISIPADU SEMEN  (ml)
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          SKOR KETUMPATAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NAMA OPERATOR
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          CATATAN
                                       </th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <template v-if="pemungutan.data.length == 0">
                                       <tr class="w-table__row" >
                                          <td class="w-table__cell text-center" colspan="10"> Tiada Data.</td>
                                       </tr>
                                    </template>
                                    <template  v-for="(dt, ind) in pemungutan.data" :key="dt.id">
                                       <tr class="w-table__row">
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{ (pemungutan.current_page - 1) * pemungutan.per_page + ind + 1 }}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{$zutil.dateformat(dt.tarikh_pemungutan)}}
                                          </td>

                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.masa_pemungutan ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.jenis_ternakan ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.jurusan_ternakan ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.baka_ternakan ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.id_ternakan ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.nama_ternakan ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.no_batch ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.no_ejekulasi ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.jumlah_penjatan_palsu ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.tujahan ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.warna_benih ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.skor_libido ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.isipadu_semen ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.skor_ketumpatan ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.nama_pemilik ?? '-'}}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{dt.catatan ?? '-'}}
                                          </td>

                                       </tr>
                                    </template>
                                 </tbody>
                              </table>
                              <br><br>
                           </div>
                        </div>

                        <table style="border:none;" width="100%">
                           <tbody>
                           <tr>
                              <td style="border: none; " width="75%" >
                                 <div class="per-page-control">
                                    <label for="perPagePemungutan" class="per-page-label">Rekod per halaman:</label>
                                    <select v-model="perPagePemungutan" @change="changePerPagePemungutan" id="perPagePemungutan" class="per-page-select">
                                       <option v-for="opt in perPageOptionsPemungutan" :key="opt" :value="opt">
                                          {{ opt }}
                                       </option>
                                    </select>
                                 </div>
                              </td>
                               <td style="border: none; " width="25%"  align="right">
                                 <nav class="pagination">
                                    <button class="pagination-btn" :disabled="!pemungutan.prev_page_url" @click="paginatePemungutan(pemungutan.prev_page_url)">
                                       Sebelumnya
                                    </button>
                                    <span class="pagination-info">
                                       {{ pemungutan.current_page }} dari {{ pemungutan.last_page }}
                                    </span>

                                    <button class="pagination-btn" :disabled="!pemungutan.next_page_url" @click="paginatePemungutan(pemungutan.next_page_url)">
                                       Seterusnya
                                    </button>
                                 </nav>
                              </td>
                           </tr>
                           </tbody>
                        </table>
                     </w-card>
               </div>

   <!-- TAB PENGELUARAN -->
               <div v-if="tab.title === 'PENGELUARAN'">
               <!-- <template  v-if="[1,3].includes(role_user)" #item-content.1 > -->

                  <br>
                  <div class="w-card__content content-hardcode mb3">
                     <w-form v-model="valid_pengeluaran" @validate="cari_pengeluaran" ref="frm_pengeluaran">

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-select class="mt4 role-selector" :items="roles" v-model="pencarian_pengeluaran.role_pengeluaran_id" label="Pilih Peranan" placeholder="Sila pilih peranan Anda" outlined color="primary" large dark />
                           </div>
                        </w-flex>
                        <br>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan"  v-model="pencarian_pengeluaran.lkp_ternakan_id" @input="getJurusanCarian(pencarian_pengeluaran.lkp_ternakan_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan"  v-model="pencarian_pengeluaran.lkp_jurusan_id" @input="getBakaCarian(pencarian_pengeluaran.lkp_jurusan_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " v-model="pencarian_pengeluaran.lkp_baka_id" :items="lkp_baka" label="Baka" />
                           </div>
                        </w-flex>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <z-select style="margin:5px; " v-model="pencarian_pengeluaran.lkp_status_id" :items="lkp_status_mp" label="Status Pengeluaran"/>
                           </div>
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_pengeluaran.no_batch" label="No Batch" />
                           </div>
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_pengeluaran.id_ternakan" label="ID Ternakan" />
                           </div>
                        </w-flex>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-input label="Tarikh Pengeluaran" type="date" v-model="pencarian_pengeluaran.tarikh_pengeluaran"/>
                           </div>
                           <div class="filter-col">
                           </div>
                           <div class="filter-col">
                           </div>
                        </w-flex>
                     </w-form>
                     <br>
                     <w-flex justify-end class="mt2">
                      <!--   <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                           <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
                        </w-button> -->
                           <w-button class="mr2" @click="resetPencarian('PENGELUARAN')" bg-color="warning">
                              <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
                           </w-button>
                           <w-button class="mr2" bg-color="primary" @click="$refs.frm_pengeluaran.validate()">
                              <w-icon>fal fa-search</w-icon>&nbsp;CARI
                           </w-button>
                        </w-flex>
                     </div>
                     <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN PENGELUARAN'">
                        <template #title>
                           SENARAI LAPORAN PENGELUARAN
                        </template>
                        <w-flex justify-end class="mt2">
                           <w-button bg-color="success" v-on="on" @click="createExcelPengeluaran()" class="mr2">
                              <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                           </w-button>
                        </w-flex>
                        <br>
                        <div class="w-table-wrap" style="max-height: 900px;">
                            <div class="table-profil-scrol">
                              <br><br>
                              <table class="w-table" color="light" style="border:1px">
                                 <thead>
                                    <tr class="w-table__header text-center" style="border: 1px solid #000;">
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          BIL
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          TARIKH PENGELUARAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NO. BATCH
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          ID TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          ISIPADU SEMEN (ML)
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          SKOR KEAKTIFAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          % MOTILITI PROGRESIF
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          KEPEKATAN SPERMA (/ML)
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          KEPEKATAN SPERMA (PER STRAW)
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          ISIPADU EXTENDER (ML)
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          JUMLAH STRAW
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          JUMLAH STRAW DIKELUARKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          % MOTILITI PROGRESIF (SEJUK)
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          % MOTILITI PROGRESIF (BEKU)
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NAMA PEMERIKSA DAN PENILAI
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          JUMLAH EXTENDER A
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          JUMLAH EXTENDER B
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          STATUS (MUSNAH/PROSES)
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          CATATAN
                                       </th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <template v-if="pengeluaran.data.length == 0">
                                       <tr class="w-table__row" >
                                          <td class="w-table__cell text-center" colspan="10"> Tiada Data.</td>
                                       </tr>
                                    </template>
                                    <template  v-for="(dt, ind) in pengeluaran.data" :key="dt.id">
                                       <tr class="w-table__row">
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{ (pengeluaran.current_page - 1) * pengeluaran.per_page + ind + 1 }}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_pengeluaran)}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_batch ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.ternakan ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.isipadu ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.stor_keaktifan ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.motiliti ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kepekatan_sperma ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kepekatan_straw ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.isipadu_extender ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jumlah_straw ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jumlah_pengeluaran ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.motiliti_sejuk ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.motiliti_beku ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_pemeriksa ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jumlah_extender_a ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jumlah_extender_b ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_status ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.catatan ?? '-'}}</td>
                                       </tr>
                                    </template>
                                 </tbody>
                              </table>
                              <br><br>
                           </div>
                        </div>

                        <table style="border:none;" width="100%">
                           <tbody>
                           <tr>
                              <td style="border: none; " width="75%" >
                                 <div class="per-page-control">
                                    <label for="perPage" class="per-page-label">Rekod per halaman:</label>
                                    <select v-model="perPage" @change="changePerPage" id="perPage" class="per-page-select">
                                       <option v-for="opt in perPageOptionsPengeluaran" :key="opt" :value="opt">
                                          {{ opt }}
                                       </option>
                                    </select>
                                 </div>
                              </td>
                               <td style="border: none; " width="25%"  align="right">
                                 <nav class="pagination">
                                    <button class="pagination-btn" :disabled="!pengeluaran.prev_page_url" @click="paginatePengeluaran(pengeluaran.prev_page_url)">
                                       Sebelumnya
                                    </button>
                                    <span class="pagination-info">
                                       {{ pengeluaran.current_page }} dari {{ pengeluaran.last_page }}
                                    </span>

                                    <button class="pagination-btn" :disabled="!pengeluaran.next_page_url" @click="paginatePengeluaran(pengeluaran.next_page_url)">
                                       Seterusnya
                                    </button>
                                 </nav>
                              </td>
                           </tr>
                           </tbody>
                        </table>
                     </w-card>
               <!-- </template> -->
               </div>

   <!-- TAB PENDAFTARAN -->
               <div v-else-if="tab.title === 'PENDAFTARAN'">
               <!-- <template #item-content.2> -->
                  <br>
                  <div class="w-card__content content-hardcode mb3">
                     <w-form v-model="valid_pendaftaran" @validate="cari_pendaftaran" ref="frm_pendaftaran">

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-select class="mt4 role-selector" :items="roles" v-model="pencarian_pendaftaran.role_pendaftaran_id" label="Pilih Peranan" placeholder="Sila pilih peranan Anda" outlined color="primary" large dark />
                           </div>
                        </w-flex>
                        <br>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan"  v-model="pencarian_pendaftaran.lkp_ternakan_pendaftaran_id" @input="getJurusanCarian(pencarian_pendaftaran.lkp_ternakan_pendaftaran_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan"  v-model="pencarian_pendaftaran.lkp_jurusan_pendaftaran_id" @input="getBakaCarian(pencarian_pendaftaran.lkp_jurusan_pendaftaran_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " v-model="pencarian_pendaftaran.lkp_baka_pendaftaran_id" :items="lkp_baka" label="Baka" />
                           </div>
                        </w-flex>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_pendaftaran.id_ternakan_pendaftaran" label="ID Ternakan" />
                           </div>
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_pendaftaran.nama_pemilik_pendaftaran" label="Nama Pemilik" />
                           </div>
                           <div class="filter-col">
                              <w-input label="Tarikh Pendaftaran" type="date" v-model="pencarian_pendaftaran.tarikh_pendaftaran"/>
                           </div>

                        </w-flex>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-input label="Tarikh Pengeluaran" type="date" v-model="pencarian_pendaftaran.tarikh_pengeluaran_pendaftaran"/>
                           </div>
                           <div class="filter-col">
                           </div>
                           <div class="filter-col">
                           </div>
                        </w-flex>
                     </w-form>
                     <br>
                        <w-flex justify-end class="mt2">
                          <!--  <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                              <w-icon>fal fa-redo</w-icon>&nbsp;RESET
                           </w-button> -->

                           <w-button class="mr2" @click="resetPencarian('PENDAFTARAN')" bg-color="warning">
                              <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
                           </w-button>
                          <!--  <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                              <w-icon>fal fa-search</w-icon>&nbsp;CARI
                           </w-button> -->
                           <w-button class="mr2" bg-color="primary" @click="$refs.frm_pendaftaran.validate()">
                              <w-icon>fal fa-search</w-icon>&nbsp;CARI
                           </w-button>
                        </w-flex>
                     </div>
                     <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN PENDAFTARAN'">
                        <template #title>
                           SENARAI LAPORAN PENDAFTARAN
                        </template>
                        <w-flex justify-end class="mt2">
                           <w-button bg-color="success" v-on="on" @click="createExcelPendaftaran()" class="mr2">
                              <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                           </w-button>
                        </w-flex>
                        <br>
                        <div class="w-table-wrap" style="max-height: 900px;">
                            <div class="table-profil-scrol">
                              <br><br>
                              <table class="w-table" color="light" style="border:1px">
                                 <thead>
                                    <tr class="w-table__header text-center" style="border: 1px solid #000;">
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          BIL
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          TARIKH PENDAFTARAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NO BATCH
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NAMA PENGELUAR SEMEN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NAMA PEMILIK
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NEGARA PENGELUAR SEMEN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          ID TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          NAMA TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          BAKA
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          TARIKH PENGELUARAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          BIL STRAW DIKELUARKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                          BIL STRAW DIDAFTARKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                         HARGA PER STRAW
                                       </th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <template v-if="pendaftaran.data.length == 0">
                                       <tr class="w-table__row" >
                                          <td class="w-table__cell text-center" colspan="10"> Tiada Data.</td>
                                       </tr>
                                    </template>
                                    <template  v-for="(dt, ind) in pendaftaran.data" :key="dt.id">
                                       <tr class="w-table__row">
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{ (pendaftaran.current_page - 1) * pendaftaran.per_page + ind + 1 }}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_pendaftaran)}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_batch ?? '-'}}</td>

                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_pengeluar ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_pemilik ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.negara ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.ternakan ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_ternakan ?? '-'}}</td>

                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.baka ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_pengeluaran)}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.bil_straw ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.bil_straw_daftar ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.harga ?? '-'}}</td>
                                       </tr>
                                    </template>
                                 </tbody>
                              </table>
                              <br><br>
                           </div>
                        </div>

                        <table style="border:none;" width="100%">
                           <tbody>
                           <tr>
                              <td style="border: none; " width="75%" >
                                 <div class="per-page-control">
                                    <label for="perPageDaftar" class="per-page-label">Rekod per halaman:</label>
                                    <select v-model="perPageDaftar" @change="changePerPageDaftar" id="perPageDaftar" class="per-page-select">
                                       <option v-for="opt in perPageOptionsDaftar" :key="opt" :value="opt">
                                          {{ opt }}
                                       </option>
                                    </select>
                                 </div>
                              </td>
                               <td style="border: none; " width="25%"  align="right">
                                 <nav class="pagination">
                                    <button class="pagination-btn" :disabled="!pendaftaran.prev_page_url" @click="paginateDaftar(pendaftaran.prev_page_url)">
                                       Sebelumnya
                                    </button>
                                    <span class="pagination-info">
                                       {{ pendaftaran.current_page }} dari {{ pendaftaran.last_page }}
                                    </span>

                                    <button class="pagination-btn" :disabled="!pendaftaran.next_page_url" @click="paginateDaftar(pendaftaran.next_page_url)">
                                       Seterusnya
                                    </button>
                                 </nav>
                              </td>
                           </tr>
                           </tbody>
                        </table>
                     </w-card>
               <!-- </template> -->
               </div>

   <!-- TAB PERMOHONAN -->
               <div v-else-if="tab.title === 'PERMOHONAN'">
               <!-- <template #item-content.3> -->
                  <br>
                  <div class="w-card__content content-hardcode mb3">
                     <w-form v-model="valid_permohonan" @validate="cari_permohonan" ref="frm_permohonan">

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-select class="mt4 role-selector" :items="roles" v-model="pencarian_permohonan.role_permohonan_id" label="Pilih Peranan" placeholder="Sila pilih peranan Anda" outlined color="primary" large dark />
                           </div>
                        </w-flex>
                        <br>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan"  v-model="pencarian_permohonan.lkp_ternakan_permohonan_id" @input="getJurusanCarian(pencarian_permohonan.lkp_ternakan_permohonan_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan"  v-model="pencarian_permohonan.lkp_jurusan_permohonan_id" @input="getBakaCarian(pencarian_permohonan.lkp_jurusan_permohonan_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " v-model="pencarian_permohonan.lkp_baka_permohonan_id" :items="lkp_baka" label="Baka" />
                           </div>
                        </w-flex>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_permohonan.id_ternakan_permohonan" label="ID Ternakan" />
                           </div>
                           <div class="filter-col">
                              <w-input label="Tarikh Permohonan" type="date" v-model="pencarian_permohonan.tarikh_permohonan"/>
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " v-model="pencarian_permohonan.lkp_status_permohonan_id"
                                 :items="[
                                    { value: 19, label: 'Draf' },
                                    { value: 16, label: 'Mohon' },
                                    { value: 21, label: 'Ditolak' },
                                    { value: 22, label: 'Lulus' },
                                 ]"
                                 label="Status"
                              />
                           </div>
                        </w-flex>
                     </w-form>
                     <br>
                        <w-flex justify-end class="mt2">
                          <!--  <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                              <w-icon>fal fa-redo</w-icon>&nbsp;RESET
                           </w-button> -->

                           <w-button class="mr2" @click="resetPencarian('PERMOHONAN')" bg-color="warning">
                              <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
                           </w-button>
                           <w-button class="mr2" bg-color="primary" @click="$refs.frm_permohonan.validate()">
                              <w-icon>fal fa-search</w-icon>&nbsp;CARI
                           </w-button>
                        </w-flex>
                     </div>
                     <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN PERMOHONAN'">
                        <template #title>
                           SENARAI LAPORAN PERMOHONAN
                        </template>
                        <w-flex justify-end class="mt2">
                           <w-button bg-color="success" v-on="on" @click="createExcelPermohonan()" class="mr2">
                              <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                           </w-button>
                        </w-flex>
                        <br>
                        <div class="w-table-wrap" style="max-height: 900px;">
                            <div class="table-profil-scrol">
                              <br><br>
                              <table class="w-table" color="light" style="border:1px">
                                 <thead>
                                    <tr class="w-table__header text-center" style="border: 1px solid #000;">
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          BIL
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                         NO PERMOHONAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                         TARIKH PERMOHONAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                         NAMA PEMOHON
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                         NEGERI PEMOHON
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                         KUANTITI DIMOHON
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                         KUANTITI DILULUSKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                         KUANTITI TIDAK LULUS
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;background:#d6e4f5;">
                                         STATUS
                                       </th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <template v-if="permohonan.data.length == 0">
                                       <tr class="w-table__row" >
                                          <td class="w-table__cell text-center" colspan="9"> Tiada Data.</td>
                                       </tr>
                                    </template>
                                    <template  v-for="(dt, ind) in permohonan.data" :key="dt.id">
                                       <tr class="w-table__row">
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{ (permohonan.current_page - 1) * permohonan.per_page + ind + 1 }}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_permohonan ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_permohonan)}}</td>

                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_pemohon ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.negeri ?? '-'}}</td>

                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kuantiti ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kuantiti_lulus ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kuantiti_tidak_lulus ?? '-'}}</td>

                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.status ?? '-'}}</td>
                                       </tr>
                                    </template>
                                 </tbody>
                              </table>
                              <br><br>
                           </div>
                        </div>

                        <table style="border:none;" width="100%">
                           <tbody>
                           <tr>
                              <td style="border: none; " width="75%" >
                                 <div class="per-page-control">
                                    <label for="perPagePermohonan" class="per-page-label">Rekod per halaman:</label>
                                    <select v-model="perPagePermohonan" @change="changePerPagePermohonan" id="perPagePermohonan" class="per-page-select">
                                       <option v-for="opt in perPageOptionsPermohonan" :key="opt" :value="opt">
                                          {{ opt }}
                                       </option>
                                    </select>
                                 </div>
                              </td>
                               <td style="border: none; " width="25%"  align="right">
                                 <nav class="pagination">
                                    <button class="pagination-btn" :disabled="!permohonan.prev_page_url" @click="paginatePermohonan(permohonan.prev_page_url)">
                                       Sebelumnya
                                    </button>
                                    <span class="pagination-info">
                                       {{ permohonan.current_page }} dari {{ permohonan.last_page }}
                                    </span>

                                    <button class="pagination-btn" :disabled="!permohonan.next_page_url" @click="paginatePermohonan(permohonan.next_page_url)">
                                       Seterusnya
                                    </button>
                                 </nav>
                              </td>
                           </tr>
                           </tbody>
                        </table>
                     </w-card>
               <!-- </template> -->
                  </div>



   <!-- TAB PENGAGIHAN -->
               <div v-else-if="tab.title === 'PENGAGIHAN'">
               <!-- <template #item-content.4> -->
                  <br>
                  <div class="w-card__content content-hardcode mb3">
                     <w-form v-model="valid_pengagihan" @validate="cari_pengagihan" ref="frm_pengagihan">
                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-select class="mt4 role-selector" :items="roles" v-model="pencarian_pengagihan.role_pengagihan_id" label="Pilih Peranan" placeholder="Sila pilih peranan Anda" outlined color="primary" large dark />
                           </div>
                        </w-flex>
                        <br>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan"  v-model="pencarian_pengagihan.lkp_ternakan_pengagihan_id" @input="getJurusanCarian(pencarian_pengagihan.lkp_ternakan_pengagihan_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan"  v-model="pencarian_pengagihan.lkp_jurusan_pengagihan_id" @input="getBakaCarian(pencarian_pengagihan.lkp_jurusan_pengagihan_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " v-model="pencarian_pengagihan.lkp_baka_pengagihan_id" :items="lkp_baka" label="Baka" />
                           </div>
                        </w-flex>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_pengagihan.nama_pemohon" label="Nama Pemohon" />
                           </div>
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_pengagihan.no_batch" label="No Batch" />
                           </div>
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_pengagihan.id_ternakan_pengagihan" label="ID Ternakan" />
                           </div>
                        </w-flex>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-input label="Tarikh Permohonan" type="date" v-model="pencarian_pengagihan.tarikh_permohonan_pengagihan"/>
                           </div>
                           <div class="filter-col">
                              <w-input label="Tarikh Agih" type="date" v-model="pencarian_pengagihan.tarikh_agih"/>
                           </div>
                           <div class="filter-col">
                           </div>
                        </w-flex>
                     </w-form>
                     <br>
                     <w-flex justify-end class="mt2">
                        <!-- <w-button class="mr2" v-on:click="resetPencarianPengagihan()" bg-color="warning">
                           <w-icon>fal fa-redo</w-icon>&nbsp;RESET</w-button> -->

                           <w-button class="mr2" @click="resetPencarian('PENGAGIHAN')" bg-color="warning">
                              <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
                           </w-button>
                           <w-button class="mr2" bg-color="primary" @click="$refs.frm_pengagihan.validate()">
                              <w-icon>fal fa-search</w-icon>&nbsp;CARI
                           </w-button>
                        </w-flex>
                     </div>
                     <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN PENGAGIHAN'">
                        <template #title>
                           SENARAI LAPORAN PENGAGIHAN
                        </template>
                        <w-flex justify-end class="mt2">
                           <w-button bg-color="success" v-on="on" @click="createExcelPengagihan()" class="mr2">
                              <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                           </w-button>
                        </w-flex>
                        <br>
                        <div class="w-table-wrap" style="max-height: 900px;">
                            <div class="table-profil-scrol">
                              <br><br>
                              <table class="w-table" color="light" style="border:1px">
                                 <thead>
                                    <tr class="w-table__header text-center" style="border: 1px solid #000;">
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          BIL
                                       </th>

                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          NO PERMOHONAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          TARIKH PERMOHONAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          NAMA PEMOHON
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          NEGERI PEMOHON
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          KUANTITI MOHON
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          KUANTITI LULUS
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          KUANTITI TIDAK LULUS
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          STATUS
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          TARIKH AGIH
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          SUDAH AGIH
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          AGIH
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          JENIS TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          BAKA
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          NO BATCH
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          JURUSAN TERNAKAN
                                       </th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <template v-if="pengagihan.data.length == 0">
                                       <tr class="w-table__row" >
                                          <td class="w-table__cell text-center" colspan="9"> Tiada Data.</td>
                                       </tr>
                                    </template>
                                    <template  v-for="(dt, ind) in pengagihan.data" :key="dt.id">
                                       <tr class="w-table__row">
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{ (permohonan.current_page - 1) * permohonan.per_page + ind + 1 }}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_permohonan ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_permohonan)}}</td>

                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_pemohon ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.negeri ?? '-'}}</td>

                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kuantiti_pemohon ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kuantiti_lulus ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kuantiti_tidak_lulus ?? '-'}}</td>

                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.status ?? '-'}}</td>


                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_agih)}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jumlah_agih ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.agih ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_ternakan ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_baka ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_batch ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_jurusan ?? '-'}}</td>
                                       </tr>
                                    </template>
                                 </tbody>
                              </table>
                              <br><br>
                           </div>
                        </div>

                        <table style="border:none;" width="100%">
                           <tbody>
                           <tr>
                              <td style="border: none; " width="75%" >
                                 <div class="per-page-control">
                                    <label for="perPagePengagihan" class="per-page-label">Rekod per halaman:</label>
                                    <select v-model="perPagePengagihan" @change="changePerPagePengagihan" id="perPagePengagihan" class="per-page-select">
                                       <option v-for="opt in perPageOptionsPengagihan" :key="opt" :value="opt">
                                          {{ opt }}
                                       </option>
                                    </select>
                                 </div>
                              </td>
                               <td style="border: none; " width="25%"  align="right">
                                 <nav class="pagination">
                                    <button class="pagination-btn" :disabled="!pengagihan.prev_page_url" @click="paginatePengagihan(pengagihan.prev_page_url)">
                                       Sebelumnya
                                    </button>
                                    <span class="pagination-info">
                                       {{ pengagihan.current_page }} dari {{ pengagihan.last_page }}
                                    </span>

                                    <button class="pagination-btn" :disabled="!pengagihan.next_page_url" @click="paginatePengagihan(pengagihan.next_page_url)">
                                       Seterusnya
                                    </button>
                                 </nav>
                              </td>
                           </tr>
                           </tbody>
                        </table>
                     </w-card>
               <!-- </template> -->
                  </div>

   <!-- TAB INVENTORI -->
               <div v-else-if="tab.title === 'INVENTORI'">
                  <!-- <template #item-content.6> -->
                  <br>
                  <div class="w-card__content content-hardcode mb3">
                     <w-form v-model="valid_inventori" @validate="cari_inventori" ref="frm_inventori">

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-select class="mt4 role-selector" :items="roles" v-model="pencarian_inventori.role_inventori_id" label="Pilih Peranan" placeholder="Sila pilih peranan Anda" outlined color="primary" large dark />
                           </div>
                        </w-flex>
                        <br>
                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan"  v-model="pencarian_inventori.lkp_ternakan_inventori_id" @input="getJurusanCarian(pencarian_inventori.lkp_ternakan_inventori_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan"  v-model="pencarian_inventori.lkp_jurusan_inventori_id" @input="getBakaCarian(pencarian_inventori.lkp_jurusan_inventori_id)" />
                           </div>
                           <div class="filter-col">
                              <z-select style="margin:5px; " v-model="pencarian_inventori.lkp_baka_inventori_id" :items="lkp_baka" label="Baka" />
                           </div>
                        </w-flex>

                        <w-flex class="mt3 filter-row">
                           <div class="filter-col">
                              <w-input style="margin:5px; " v-model="pencarian_inventori.id_ternakan_inventori" label="ID Ternakan" />
                           </div>
                           <div class="filter-col">
                              <w-input label="Tarikh Daftar" type="date" v-model="pencarian_inventori.tarikh_pendaftaran_inventori"/>
                           </div>
                           <div class="filter-col">
                               <!--  <w-input style="margin:5px; " v-model="pencarian_inventori.nama_pemohon_inventori" label="Nama Pemohon" />
                           &nbsp; -->
                           </div>
                        </w-flex>
                     </w-form>
                     <br>
                     <w-flex justify-end class="mt2">
                        <!-- <w-button class="mr2" v-on:click="resetPencarianPengagihan()" bg-color="warning">
                           <w-icon>fal fa-redo</w-icon>&nbsp;RESET</w-button> -->

                           <w-button class="mr2" @click="resetPencarian('INVENTORI')" bg-color="warning">
                              <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA
                           </w-button>
                           <w-button class="mr2" bg-color="primary" @click="$refs.frm_inventori.validate()">
                              <w-icon>fal fa-search</w-icon>&nbsp;CARI
                           </w-button>
                        </w-flex>
                     </div>
                     <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN INVENTORI'">
                        <template #title>
                           SENARAI LAPORAN INVENTORI
                        </template>
                        <w-flex justify-end class="mt2">
                           <w-button bg-color="success" v-on="on" @click="createExcelInventori()" class="mr2">
                              <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                           </w-button>
                        </w-flex>
                        <br>
                        <div class="w-table-wrap" style="max-height: 900px;">
                            <div class="table-profil-scrol">
                              <br><br>
                              <table class="w-table" color="light" style="border:1px">
                                 <thead>
                                    <tr class="w-table__header text-center" style="border: 1px solid #000;">
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                          BIL
                                       </th>

                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             TARIKH DAFTAR
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             SUMBER
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             NEGERI
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             NAMA PEMOHON
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             JENIS TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             BAKA
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             ID TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             NAMA TERNAKAN
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             NO BATCH
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             KUANTITI DAFTAR
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             KUANTITI MOHON
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             KUANTITI LULUS
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             KUANTITI TERPAKAI
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             DILUPUS/ ROSAK
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             DIUJI
                                       </th>
                                       <th class="w-table__header text-center" style="border: 1px solid #000;  background:#d6e4f5;">
                                             BAKI STRAW
                                       </th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <template v-if="inventori.data.length == 0">
                                       <tr class="w-table__row" >
                                          <td class="w-table__cell text-center" colspan="9"> Tiada Data.</td>
                                       </tr>
                                    </template>
                                    <template  v-for="(dt, ind) in inventori.data" :key="dt.id">
                                       <tr class="w-table__row">
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">
                                             {{ (permohonan.current_page - 1) * permohonan.per_page + ind + 1 }}
                                          </td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh)}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.sumber ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.negeri ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_pemohon ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_ternakan ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.baka ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.ternakan ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_ternakan ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_batch ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kuantiti_daftar ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kuantiti_dimohon ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kuantiti_lulus ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.terpakai ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.rusak ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.diuji ?? '-'}}</td>
                                          <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.baki ?? '-'}}</td>
                                       </tr>


                                    </template>
                                 </tbody>
                              </table>
                              <br><br>
                           </div>
                        </div>

                        <table style="border:none;" width="100%">
                           <tbody>
                           <tr>
                              <td style="border: none; " width="75%" >
                                 <div class="per-page-control">
                                    <label for="perPageInventori" class="per-page-label">Rekod per halaman:</label>
                                    <select v-model="perPageInventori" @change="changePerPageInventori" id="perPageInventori" class="per-page-select">
                                       <option v-for="opt in perPageOptionsInventori" :key="opt" :value="opt">
                                          {{ opt }}
                                       </option>
                                    </select>
                                 </div>
                              </td>
                               <td style="border: none; " width="25%"  align="right">
                                 <nav class="pagination">
                                    <button class="pagination-btn" :disabled="!inventori.prev_page_url" @click="paginateInventori(inventori.prev_page_url)">
                                       Sebelumnya
                                    </button>
                                    <span class="pagination-info">
                                       {{ inventori.current_page }} dari {{ inventori.last_page }}
                                    </span>

                                    <button class="pagination-btn" :disabled="!inventori.next_page_url" @click="paginateInventori(inventori.next_page_url)">
                                       Seterusnya
                                    </button>
                                 </nav>
                              </td>
                           </tr>
                           </tbody>
                        </table>
                     </w-card>
               <!-- </template> -->
               </div>



               </template>

            </w-tabs>
         </div>
      </z-page>
   </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    // items: [Array, Object],
    // role_user: Number,
   role_user: {
    type: Array,
    required: true
  },
    role: String,
    roles: [Array, Object],
    pengeluaran: [Array, Object],
    pendaftaran: [Array, Object],
    permohonan: [Array, Object],
    pengagihan: [Array, Object],
    pemungutan: [Array, Object],
    inventori: [Array, Object],
    segmenName: [Array, Object]

  },
  data() {
    return {
      resourceurl: 'laporan.semen',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan', route: '/laporan' },
        { label: 'Semen', route: 'laporan/semen' },
      ],
      activeTab: 0,
      // tabs: [
      //   // ...(this.role_user === 1 ? [{ title: 'PERMOHONAN', content: '' }] : []),
      //   ...([1, 3].includes(this.role_user) ? [{ title: 'PENGELUARAN', content: '' }] : []),
      //   ...([1, 3].includes(this.role_user) ? [{ title: 'PENDAFTARAN', content: '' }] : []),
      //   { title: 'PERMOHONAN', content: ''},
      //   { title: 'PENGAGIHAN', content: ''},
      // ],

      form : this.datas,


      pencarian_pengeluaran: {
         lkp_ternakan_id: '',
         lkp_baka_id: '',
         lkp_jurusan_id: '',
         tarikh_pengeluaran: '',
         lkp_status_id: '',
         no_batch: '',
         id_ternakan: '',
         role_pengeluaran_id: this.role,

      },
       pencarian_pendaftaran: {
         lkp_ternakan_pendaftaran_id: '',
         lkp_baka_pendaftaran_id: '',
         lkp_jurusan_pendaftaran_id: '',
         tarikh_pendaftaran: '',
         tarikh_pengeluaran_pendaftaran: '',
         id_ternakan_pendaftaran: '',
         role_pendaftaran_id: this.role,
         nama_pemilik_pendaftaran: '',

      },
      pencarian_permohonan: {
         lkp_ternakan_permohonann_id: '',
         lkp_baka_permohonan_id: '',
         lkp_jurusan_permohonan_id: '',
         tarikh_permohonann: '',
         id_ternakan_permohonan: '',
         lkp_status_permohonan_id: '',
         role_permohonan_id: this.role,

      },
      pencarian_pengagihan: {
         lkp_ternakan_pengagihan_id: '',
         lkp_baka_pengagihan_id: '',
         lkp_jurusan_pengagihan_id: '',
         tarikh_permohonann_pengagihan: '',
         id_ternakan_pengagihan: '',
         tarikh_agih: '',
         nama_pemohon: '',
         no_batch: '',
         role_pengagihan_id: this.role,

      },
      pencarian_pemungutan: {
         lkp_ternakan_pemungutan_id: '',
         lkp_baka_pemungutan_id: '',
         lkp_jurusan_pemungutan_id: '',
         id_ternakan_pemungutan: '',
         tarikh_pemungutan: '',
         nama_pemungutan: '',
         role_pemungutan_id: this.role,

      },

       pencarian_inventori: {
         lkp_ternakan_inventori_id: '',
         lkp_baka_inventori_id: '',
         lkp_jurusan_inventori_id: '',
         tarikh_pendaftaran_inventori: '',
         id_ternakan_inventori: '',
         // nama_pemohon_inventori: '',
         role_inventori_id: this.role,

      },

      lkp_status_mp: [],
       lkp_jurusan :[],
       lkp_ternakan : [],
       lkp_baka : [],
      perPageOptionsPengeluaran: [5, 10, 50, 99],
      perPage: this.pengeluaran.per_page || 10,
      perPageOptionsDaftar: [5, 10, 50, 99],
      perPageDaftar: this.pendaftaran.per_page || 10,
      perPageOptionsPermohonan: [5, 10, 50, 99],
      perPagePermohonan: this.permohonan.per_page || 10,

      perPageOptionsPengagihan: [5, 10, 50, 99],
      perPagePengagihan: this.pengagihan.per_page || 10,

      perPageOptionsPemungutan: [5, 10, 50, 99],
      perPagePemungutan: this.pemungutan.per_page || 10,

      perPageOptionsInventori: [5, 10, 50, 99],
      perPageInventori: this.inventori.per_page || 10,


    }
  },

  computed: {
  tabs() {
    return [
      ...(this.hasRole([1,3]) ? [{ title: 'PEMUNGUTAN', content: '' }] : []),
      ...(this.hasRole([1,3]) ? [{ title: 'PENGELUARAN', content: '' }] : []),
      // ...(this.hasRole([1,3]) ? [{ title: 'PENDAFTARAN', content: '' }] : []),
      { title: 'PENDAFTARAN', content: '' },
      { title: 'PERMOHONAN', content: '' },
      { title: 'PENGAGIHAN', content: '' },
      { title: 'INVENTORI', content: '' },
    ]
  }
},

  methods: {

   hasRole(roles) {
    return roles.some(r => this.role_user.includes(r))
  },

   paginatePengeluaran(url) {
      const page = new URL(url).searchParams.get('page_pengeluaran');
      const params = {
         ...this.pencarian_pengeluaran,
         page_pengeluaran: page,
      };

      this.$inertia.get(url, params, {
         preserveState: true,
         preserveScroll: true,
      });
   },

   paginateDaftar(url) {
      const page = new URL(url).searchParams.get('page_pendaftaran');
      const params = {
         ...this.pencarian_pendaftaran,
         page_pendaftaran: page,
      };

      this.$inertia.get(url, params, {
         preserveState: true,
         preserveScroll: true,
      });
   },

   paginatePermohonan(url) {
      const page = new URL(url).searchParams.get('page_permohonan');
      const params = {
         ...this.pencarian_permohonan,
         page_permohonan: page,
      };

      this.$inertia.get(url, params, {
         preserveState: true,
         preserveScroll: true,
      });
   },


   paginatePengagihan(url) {
      const page = new URL(url).searchParams.get('page_pengagihan');
      const params = {
         ...this.pencarian_pengagihan,
         page_pengagihan: page,
      };

      this.$inertia.get(url, params, {
         preserveState: true,
         preserveScroll: true,
      });
   },

   paginatePemungutan(url) {
      const page = new URL(url).searchParams.get('page_pemungutan');
      const params = {
         ...this.pencarian_pemungutan,
         page_pemungutan: page,
      };

      this.$inertia.get(url, params, {
         preserveState: true,
         preserveScroll: true,
      });
   },

   paginateInventori(url) {
      const page = new URL(url).searchParams.get('page_inventori');
      const params = {
         ...this.pencarian_inventori,
         page_inventori: page,
      };

      this.$inertia.get(url, params, {
         preserveState: true,
         preserveScroll: true,
      });
   },



   cari_pengeluaran() {
      if(!this.valid_pengeluaran) return;
      // const page = new URL(url).searchParams.get('page_pengeluaran');
      const page = this.$page.url ? new URL(this.$page.url, window.location.origin).searchParams.get('page_pengeluaran') : 1;

      let params = {
         ...this.pencarian_pengeluaran,
         page_pengeluaran: page,
      };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    cari_pendaftaran() {
       if(!this.valid_pendaftaran) return;
      // const page = new URL(url).searchParams.get('page_pendaftaran');

      const page = this.$page.url ? new URL(this.$page.url, window.location.origin).searchParams.get('page_pendaftaran') : 1;

       let params = {
       ...this.pencarian_pendaftaran,
         page_pendaftaran: page,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    cari_permohonan() {
       if(!this.valid_permohonan) return;
      // const page = new URL(url).searchParams.get('page_pengagihan');
       const page = this.$page.url ? new URL(this.$page.url, window.location.origin)
      .searchParams.get('page_pengagihan') : 1;

       let params = {
       ...this.pencarian_permohonan,
         page_pengagihan: page,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    cari_pengagihan() {
       if(!this.valid_pengagihan) return;
      // const page = new URL(url).searchParams.get('page_pengeluaran');

      const page = this.$page.url ? new URL(this.$page.url, window.location.origin)
      .searchParams.get('page_pengagihan') : 1;

       let params = {
       ...this.pencarian_pengagihan,
         page_pengeluaran: page,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    cari_pemungutan() {
       if(!this.valid_pemungutan) return;
      // const page = new URL(url).searchParams.get('page_pengeluaran');

      const page = this.$page.url ? new URL(this.$page.url, window.location.origin)
      .searchParams.get('page_pemungutan') : 1;

       let params = {
       ...this.pencarian_pemungutan,
         page_pemungutan: page,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

   cari_inventori() {
       if(!this.valid_inventori) return;
      // const page = new URL(url).searchParams.get('page_pengeluaran');

      const page = this.$page.url ? new URL(this.$page.url, window.location.origin)
      .searchParams.get('page_inventori') : 1;

       let params = {
       ...this.pencarian_inventori,
         page_inventori: page,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },



   setTabFromQuery() {
      const params = new URLSearchParams(window.location.search)
      const q = params.get('tab')
      if (q) {
         const idx = this.tabs.findIndex(t => t.title.toLowerCase() === q.toLowerCase())
         this.activeTab = idx !== -1 ? idx : 0
      } else {
         this.activeTab = 0
      }
   },

   resetPencarian(tabTujuan = null) {
      const params = new URLSearchParams()
      if (tabTujuan) {
         params.set('tab', tabTujuan.toLowerCase())
      }

      const url = window.location.pathname + (params.toString() ? '?' + params.toString() : '')

      // visit, biar setelah reload mounted() set activeTab dari query
      this.$inertia.visit(url)
   },




    getTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },
    getJurusanCarian(i){
         this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
           this.lkp_jurusan = res
         })
       },
    getBakaCarian(i){
         this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
           this.lkp_baka = res
         })
       },

   getStatusMp(){
      this.$zcomm.get(this.api_service + 'lookup/status_mp', {}).then(res => {
        this.lkp_status_mp = res
      })
    },


   createExcelPengeluaran() {
      const params = {
         lkp_ternakan_id: this.pencarian_pengeluaran.lkp_ternakan_id || '',
         lkp_jurusan_id: this.pencarian_pengeluaran.lkp_jurusan_id || '',
         lkp_baka_id: this.pencarian_pengeluaran.lkp_baka_id || '',
         tarikh_pengeluaran: this.pencarian_pengeluaran.tarikh_pengeluaran || '',
         lkp_status_id: this.pencarian_pengeluaran.lkp_status_id || '',
         no_batch: this.pencarian_pengeluaran.no_batch || '',
         id_ternakan: this.pencarian_pengeluaran.id_ternakan || '',
         role_pengeluaran_id: this.pencarian_pengeluaran.role_pengeluaran_id || '',
         // per_page: this.perPage || 10,
         excel: 1 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan.semen') + '?' + queryString;
      window.open(url, '_blank');

    // const url = route('laporan.service.service_ai') + '?' + new URLSearchParams(params).toString();
    // window.open(url, '_blank');
   },

   createExcelPendaftaran() {
      const params = {
         lkp_ternakan_pendaftaran_id: this.pencarian_pendaftaran.lkp_ternakan_pendaftaran_id || '',
         lkp_jurusan_pendaftaran_id: this.pencarian_pendaftaran.lkp_jurusan_pendaftaran_id || '',
         lkp_baka_pendaftaran_id: this.pencarian_pendaftaran.lkp_baka_pendaftaran_id || '',
         tarikh_pendaftaran: this.pencarian_pendaftaran.tarikh_pendaftaran || '',
         tarikh_pengeluaran_pendaftaran: this.pencarian_pendaftaran.tarikh_pengeluaran_pendaftaran || '',
         id_ternakan_pendaftaran: this.pencarian_pendaftaran.id_ternakan_pendaftaran || '',
         role_pendaftaran_id: this.pencarian_pendaftaran.role_pendaftaran_id || '',
         nama_pemilik_pendaftaran: this.pencarian_pendaftaran.nama_pemilik_pendaftaran || '',
         // per_page: this.perPage || 10,
         excel: 2 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan.semen') + '?' + queryString;
      window.open(url, '_blank');
   },


   createExcelPermohonan() {
      const params = {
         lkp_ternakan_permohonann_id: this.pencarian_permohonan.lkp_ternakan_permohonann_id || '',
         lkp_jurusan_permohonan_id: this.pencarian_permohonan.lkp_jurusan_permohonan_id || '',
         lkp_baka_permohonan_id: this.pencarian_permohonan.lkp_baka_permohonan_id || '',
         tarikh_permohonann: this.pencarian_permohonan.tarikh_permohonann || '',
         id_ternakan_permohonan: this.pencarian_permohonan.id_ternakan_permohonan || '',
         role_permohonan_id: this.pencarian_permohonan.role_permohonan_id || '',
         // per_page: this.perPage || 10,
         excel: 3 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan.semen') + '?' + queryString;
      window.open(url, '_blank');
   },

   createExcelPengagihan() {
      const params = {
         lkp_ternakan_pengagihan_id: this.pencarian_pengagihan.lkp_ternakan_pengagihan_id || '',
         lkp_jurusan_pengagihan_id: this.pencarian_pengagihan.lkp_jurusan_pengagihan_id || '',
         lkp_baka_pengagihan_id: this.pencarian_pengagihan.lkp_baka_pengagihan_id || '',
         tarikh_permohonann_pengagihan: this.pencarian_pengagihan.tarikh_permohonann_pengagihan || '',
         id_ternakan_pengagihan: this.pencarian_pengagihan.id_ternakan_pengagihan || '',
         nama_pemohon: this.pencarian_pengagihan.nama_pemohon || '',
         no_batch: this.pencarian_pengagihan.no_batch || '',
         tarikh_agih: this.pencarian_pengagihan.tarikh_agih || '',
         role_pengagihan_id: this.pencarian_pengagihan.role_pengagihan_id || '',


         // per_page: this.perPage || 10,
         excel: 4 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan.semen') + '?' + queryString;
      window.open(url, '_blank');
   },


   createExcelPemungutan() {
      const params = {
         lkp_ternakan_pemungutan_id: this.pencarian_pemungutan.lkp_ternakan_pemungutan_id || '',
         lkp_baka_pemungutan_id: this.pencarian_pemungutan.lkp_baka_pemungutan_id || '',
         lkp_jurusan_pemungutan_id: this.pencarian_pemungutan.lkp_jurusan_pemungutan_id || '',
         id_ternakan_pemungutan: this.pencarian_pemungutan.id_ternakan_pemungutan || '',
         tarikh_pemungutan: this.pencarian_pemungutan.tarikh_pemungutan || '',
         nama_pemungutan: this.pencarian_pemungutan.nama_pemungutan || '',
         role_pemungutan_id: this.pencarian_pemungutan.role_pemungutan_id || '',


         // per_page: this.perPage || 10,
         excel: 5 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan.semen') + '?' + queryString;
      window.open(url, '_blank');
   },

   createExcelInventori() {
      const params = {
         lkp_ternakan_inventori_id: this.pencarian_inventori.lkp_ternakan_inventori_id || '',
         lkp_jurusan_inventori_id: this.pencarian_inventori.lkp_jurusan_inventori_id || '',
         lkp_baka_inventori_id: this.pencarian_inventori.lkp_baka_inventori_id || '',
         tarikh_pendaftaran_inventori: this.pencarian_inventori.tarikh_pendaftaran_inventori || '',
         id_ternakan_pendaftaran: this.pencarian_inventori.id_ternakan_pendaftaran || '',
         id_ternakan_inventori: this.pencarian_inventori.id_ternakan_inventori || '',

         // per_page: this.perPage || 10,
         excel: 6 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan.semen') + '?' + queryString;
      window.open(url, '_blank');
   },


   changePerPage() {
      let params = {
         ...this.pencarian_pengeluaran,
         // per_page: this.perPage,
         // page: 1

         per_page_pengeluaran: this.perPage,
         page_pengeluaran: 1
      };
      this.$inertia.visit(route(route().current(), params), {
         preserveState: true,
         preserveScroll: true,
      });
   },


   changePerPageDaftar() {
      let params = {
         ...this.pencarian_pendaftaran,
         // perPageDaftar: this.perPageDaftar,
         // page: 1

         per_page_pendaftaran: this.perPageDaftar,
         page_pendaftaran: 1
      };
      this.$inertia.visit(route(route().current(), params), {
         preserveState: true,
         preserveScroll: true,
      });
   },

   changePerPagePermohonan() {
      let params = {
         ...this.pencarian_permohonan,
         per_page_permohonan: this.perPagePermohonan,
         page_permohonan: 1
      };
      this.$inertia.visit(route(route().current(), params), {
         preserveState: true,
         preserveScroll: true,
      });
   },

   changePerPagePengagihan() {
      let params = {
         ...this.pencarian_pengagihan,
         // perPagePengagihan: this.perPagePengagihan,
         // page: 1

         per_page_pengagihan: this.perPagePengagihan,
         page_pengagihan: 1
      };
      this.$inertia.visit(route(route().current(), params), {
         preserveState: true,
         preserveScroll: true,
      });
   },

   changePerPagePemungutan() {
      let params = {
         ...this.pencarian_pemungutan,
         // perPagePengagihan: this.perPagePengagihan,
         // page: 1

         per_page_pemungutan: this.perPagePemungutan,
         page_pemungutan: 1
      };
      this.$inertia.visit(route(route().current(), params), {
         preserveState: true,
         preserveScroll: true,
      });
   },

   changePerPageInventori() {
      let params = {
         ...this.pencarian_inventori,
         // perPagePengagihan: this.perPagePengagihan,
         // page: 1

         per_page_inventori: this.perPageInventori,
         page_inventori: 1
      };
      this.$inertia.visit(route(route().current(), params), {
         preserveState: true,
         preserveScroll: true,
      });
   },




  },

   watch: {
  //  tabs: {
  //   handler() { this.setTabFromQuery() },
  //   immediate: true
  // }

      'pencarian_pengeluaran.role_pengeluaran_id'(val) {
         clearTimeout(this._roleTimer)

         // bila kosong → reset
         if (!val) {
            this.resetPencarian('pengeluaran')
            return
         }

         // bila pilih → auto cari
         this._roleTimer = setTimeout(() => {
            this.$refs.frm_pengeluaran?.validate()
         }, 300)
      },

      'pencarian_pendaftaran.role_pendaftaran_id'(val) {
         clearTimeout(this._roleTimer)

         if (!val) {
            this.resetPencarian('pendaftaran')
            return
         }

         this._roleTimer = setTimeout(() => {
            this.$refs.frm_pendaftaran?.validate()
         }, 300)
      },

      'pencarian_permohonan.role_permohonan_id'(val) {
         clearTimeout(this._roleTimer)

         if (!val) {
            this.resetPencarian('permohonan')
            return
         }

         this._roleTimer = setTimeout(() => {
            this.$refs.frm_permohonan?.validate()
         }, 300)
      },

      'pencarian_pengagihan.role_pengagihan_id'(val) {
         clearTimeout(this._roleTimer)

         if (!val) {
            this.resetPencarian('pengagihan')
            return
         }

         this._roleTimer = setTimeout(() => {
            this.$refs.frm_pengagihan?.validate()
         }, 300)
      },


      'pencarian_pemungutan.role_pemungutan_id'(val) {
         clearTimeout(this._roleTimer)

         if (!val) {
            this.resetPencarian('pemungutan')
            return
         }

         this._roleTimer = setTimeout(() => {
            this.$refs.frm_pemungutan?.validate()
         }, 300)
      },

      'pencarian_inventori.role_inventori_id'(val) {
         clearTimeout(this._roleTimer)

         if (!val) {
            this.resetPencarian('inventori')
            return
         }

         this._roleTimer = setTimeout(() => {
            this.$refs.frm_inventori?.validate()
         }, 300)
      }

   },

  mounted() {
    this.getTernakan();
    this.getStatusMp();
    // override default setting
    this.dialog.width = 500

    // set tab berdasarkan query string saat halaman dimuat
    this.setTabFromQuery()

  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}

.per-page-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.per-page-label {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.per-page-select {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.per-page-select:hover {
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.4);
}


.w-table thead tr:nth-child(1) th {
  position: sticky;
  top: 2px;
  background: #fff;
  z-index: 3;
}

/* Header baris kedua */
.w-table thead tr:nth-child(2) th {
  position: sticky;
  top: 32px; /* sesuaikan dengan tinggi row pertama */
  background: #fff;
  z-index: 2;
}

.role-selector {
  width: 100%;
  max-width: 400px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.role-selector .w-select__selection {
  padding: 12px 16px;
  font-size: 16px;
}

.role-selector .w-select__label {
  font-weight: bold;
  color: #1976d2;
}

.filter-row {
  display: flex;
  gap: 10px;
}

.filter-col {
  flex: 1;
  min-width: 220px; /* optional – elak jadi terlalu kecil */
}
</style>
